var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarnings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.60114 0.633911C9.15998 0.633911 8.71881 0.801554 8.35706 1.15449L1.29842 8.21313C0.601375 8.90135 0.601375 10.0131 1.29842 10.7013L8.35706 17.7599C9.04528 18.457 10.157 18.457 10.8452 17.7599L17.9039 10.7013C18.6009 10.0131 18.6009 8.90135 17.9039 8.21313L10.8452 1.15449C10.4835 0.801554 10.0423 0.633911 9.60114 0.633911ZM9.60114 2.39857L16.6598 9.45721L9.60114 16.5159L2.5425 9.45721M8.71881 5.04556V10.3395H10.4835V5.04556M8.71881 12.1042V13.8689H10.4835V12.1042H8.71881Z",
    fill: "#EDC03B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarnings);
export default __webpack_public_path__ + "static/media/warnings.43c999a6c6b38c311b4dcba29503df2d.svg";
export { ForwardRef as ReactComponent };